// LICENSE_CODE ZON
'use strict'; /*jslint browser:true, es6:true, node:true, react:true*/
import React, {useMemo} from 'react';
import {LinkProps} from 'react-router-dom';
import cn from 'classnames';
import zurl from '/util/url.js';
import {Basic_button, i_basic_button_variants, t_native_anchor_props,
    t_native_button_props} from './basic_button';
import styles from './button.module.less';

export type t_button_size = 'xxs'|'xs'|'sm'|'md'|'lg'|'xl';
export type t_button_color = 'primary' | 'secondary' | 'tertiary' | 'social'
    | 'transparent';

type t_common_button_props = {
    color?: t_button_color;
    size?: t_button_size;
    caption: React.ReactNode;
    cls?: string;
    disabled?: boolean;
    clickid?: string;
    tab_index?: string;
    icon_left?: JSX.Element;
    icon_right?: JSX.Element;
    fit?: boolean;
    full_width?: boolean;
    icon_only?: boolean;
    on_click?: (ev?: React.MouseEvent) => void;
}

type t_button_link_props = t_common_button_props & {
    to: string;
    as_external?: boolean;
    target?: string;
}

type t_button_button_props = t_common_button_props & {
    to?: never;
    as_external?: never;
    target?: never;
}

type i_button_props = t_button_link_props | t_button_button_props;

export const Button = (props: i_button_props)=>{
    const {color = 'primary', size = 'md', cls, to, on_click, target,
        as_external, disabled, clickid, tab_index, fit = true, full_width,
        icon_only, ...rest} = props;
    const is_external = as_external || (to ? !!zurl.parse(to).host : false);
    const tag_config = useMemo<i_basic_button_variants>(()=>{
        const base_props = {
            onClick: on_click,
            disabled,
            tabIndex: tab_index,
            'data-clickid': clickid,
            'data-size': size,
            'data-color': color,
        };
        if (!to)
        {
            return {
                tag: 'button',
                button_props: {
                    ...base_props,
                } as unknown as t_native_button_props,
            };
        }
        if (is_external)
        {
            const target_props = target == '_blank' ? {
                target: '_blank',
                rel: 'noopener noreferrer'
            } : {};
            return {
                tag: 'a',
                button_props: {
                    href: to,
                    ...base_props,
                    ...target_props,
                } as unknown as t_native_anchor_props,
            };
        }
        return {
            tag: 'link',
            button_props: {
                ...base_props,
                to,
                onClick: on_click
            } as unknown as LinkProps,
        };
    }, [
        to, is_external, on_click, target, color, disabled, tab_index, clickid
    ]);
    const btn_cls = cn(styles.button, cls, {
        [styles.fit]: fit,
        [styles.full_width]: full_width,
        [styles.icon_only]: icon_only,
    });
    return <Basic_button {...tag_config} cls={btn_cls} {...rest}/>;
};
